module.exports = __webpack_public_path__ + "static/img/ikonaGimpDisabled-ON.8216ea51.png";